import { render, staticRenderFns } from "./roleManagement.vue?vue&type=template&id=1ffb2f98"
import script from "./roleManagement.vue?vue&type=script&lang=js"
export * from "./roleManagement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports